(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // ---------------- Header ----------------
    const root = document.documentElement;
      const header = document.querySelector(".bd-header");
      if (!header) return;

      const setHeaderHeight = () => {
        const h = header.getBoundingClientRect().height;
        root.style.setProperty("--header-height", Math.max(0, Math.round(h)) + "px");
      };

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", setHeaderHeight, { once: true });
      } else {
        setHeaderHeight();
      }
      window.addEventListener("load", setHeaderHeight, { once: true });

      if (window.ResizeObserver) {
        const ro = new ResizeObserver(() => setHeaderHeight());
        ro.observe(header);
        header.querySelectorAll("*").forEach(el => ro.observe(el));
      }
      const onViewportChange = () => requestAnimationFrame(setHeaderHeight);
      window.addEventListener("resize", onViewportChange);
      if (window.visualViewport) {
        visualViewport.addEventListener("resize", onViewportChange);
      }
      window.addEventListener("orientationchange", onViewportChange);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(setHeaderHeight);
      }

      let ticking = false;
      window.addEventListener("scroll", () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(() => {
            setHeaderHeight();
            ticking = false;
          });
        }
      }, { passive: true });
    // ---------------- mega menu slider ----------------
    if (document.querySelector('[js-mega-menu-slider]')) {
      new Swiper("[js-mega-menu-slider]", {
        slidesPerView: 2.7185,
        spaceBetween: 8,
        watchSlidesProgress: true,
        draggable: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        mousewheel: {
          forceToAxis: true
        },
      });
    }
    if (document.querySelector('[js-desk-mega-menu]')) {
      new Swiper("[js-desk-mega-menu]", {
        spaceBetween: 13,
        watchSlidesProgress: true,
        draggable: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        mousewheel: {
          forceToAxis: true
        },
        breakpoints: {
          960: {
            slidesPerView: 5,
            spaceBetween: 10
          },
          1280: {
            slidesPerView: 7.45,
            spaceBetween: 13
          }
        }
      });
    }
    const triggers = document.querySelectorAll(".navigation__submenu-trigger");
    triggers.forEach(trigger => {
      const submenu = trigger.nextElementSibling;
  
      if (!submenu) return;
  
      trigger.addEventListener("mouseenter", () => {
        submenu.classList.add("active");
      });

      trigger.addEventListener("mouseleave", (e) => {
        if (!submenu.contains(e.relatedTarget)) {
          submenu.classList.remove("active");
        }
      });

      submenu.addEventListener("mouseenter", () => {
        submenu.classList.add("active");
      });
  
      submenu.addEventListener("mouseleave", (e) => {
        if (!trigger.contains(e.relatedTarget)) {
          submenu.classList.remove("active");
        }
      });
    });
    // ---------------- Variant Popup ----------------

    window.initVariantDropdown = function() {
      const openBtns = document.querySelectorAll("[js-variant-model]");
      const overlay = document.querySelector("[js-variant-overlay]");
      const bdProduct = document.querySelector("[js-bd-product]");
      const closeBtns = document.querySelectorAll("[js-close-popup]");
      const allPopups = document.querySelectorAll("[js-variant-popup], [js-chart-size]");
      
      function sizeChartScript(){
        const sizeChartPopup = document.querySelector("[js-chart-size]");
        const chartSizeOpenBtns = document.querySelectorAll("[js-chart-size-model]");
        const sizchartOverlay = document.querySelector("[js-sizechart-overlay]");
        const sizeChartCloseBtns = document.querySelectorAll("[js-size-close-popup]");
        chartSizeOpenBtns.forEach(btn => {
          const chartSizePopup = document.querySelector("[js-chart-size]");
          btn.addEventListener("click", function() {
            if (chartSizePopup && chartSizePopup.classList.contains("open")) {
              sizchartOverlay.classList.remove("open");
              chartSizePopup.classList.remove("open");
              bdProduct.classList.remove("popup-active");
            } else {
              sizchartOverlay.classList.add("open");
              if (chartSizePopup) chartSizePopup.classList.add("open");
              bdProduct.classList.add("popup-active");
            }
          });
        });
        sizeChartCloseBtns.forEach(btn => {
          btn.addEventListener("click", function(){
            sizchartOverlay.classList.remove("open");
            sizeChartPopup.classList.remove("open");
            bdProduct.classList.remove("popup-active");
          });
        });
        sizchartOverlay?.addEventListener("click", function(){
          sizchartOverlay.classList.remove("open");
          sizeChartPopup.classList.remove("open");
          bdProduct.classList.remove("popup-active");
        });
      }
      sizeChartScript()
      // document.addEventListener('popup-scripts:init', sizeChartScript)
      function togglePopup(targetPopup) {
        if (targetPopup && targetPopup.classList.contains("open")) {
          overlay.classList.remove("open");
          targetPopup.classList.remove("open");
          bdProduct.classList.remove("popup-active");
        } else {
          overlay.classList.add("open");
          if (targetPopup) targetPopup.classList.add("open");
          bdProduct.classList.add("popup-active");
        }
      }
      function closeAllPopups() {
        overlay?.classList.remove("open");
        allPopups?.forEach(p => p.classList.remove("open"));
        bdProduct?.classList.remove("popup-active");
      }
      openBtns.forEach(btn => {
        const popup = document.querySelector("[js-variant-popup]");
        btn.addEventListener("click", () => togglePopup(popup));
      });
      
      closeBtns.forEach(btn => {
        btn.addEventListener("click", closeAllPopups);
      });
      overlay?.addEventListener("click", closeAllPopups);
   
      const selectedImage = document.querySelector("[js-selected-variant-image] img");
      const selectedValue = document.querySelector("[js-selected-option-value]");
      const variantPriceEl = document.querySelector("[js-variant-price]");
      const variantUnitPriceEl = document.querySelector("[js-variant-unit-price]");
      const variantRadios = document.querySelectorAll(".variant-popup--input, .variant-wrapper input[type=radio]");
      const variantSelects = document.querySelectorAll("select[data-index]");
      variantRadios.forEach(radio => {
        radio.addEventListener("click", () => {
          if (!radio.checked) return;
          const label = radio.closest("label");
          const optionWrapper = radio.closest(".product-flavor > div");
          const optionName = optionWrapper?.dataset.optionName;
          const optionTitle = label.querySelector("[js-option-value]")?.getAttribute("data-option-title");
          const variantValue = label.querySelector("[js-option-value]")?.getAttribute("data-option-vlaue")?.trim()
                            || label.querySelector("[data-option-vlaue]")?.getAttribute("data-option-vlaue")?.trim();
          const variantImage = label.querySelector("[js-variant-image] img")?.getAttribute("src");
          const variantPrice = label.querySelector(".variant-price");
          const variantUnitPrice = label.querySelector(".variant-unit-price");
          

          if (variantValue) {

            /* DUPLICATE BUNDLE FIX BY ELBDEV ED-482 */
            let scopedVariantSelects = variantSelects;
            if(radio.closest('.variant-wrapper')?.getAttribute('ed-two-options')) {
              scopedVariantSelects = [...variantSelects].filter((select) => {
                return select.id === radio.name
              });
            }

            scopedVariantSelects.forEach(select => {
              const matchingOption = [...select.options].find(
                opt => opt.value.trim() === variantValue
              );
              if (matchingOption) {
                matchingOption.selected = true;
                select.dispatchEvent(new Event("change", { bubbles: true }));
              }
            });
          }

          if (optionName?.includes("Geschmacksrichtungen")) {
            if (selectedImage && variantImage) {
              selectedImage.setAttribute("src", variantImage);
            }
            if (selectedValue && optionTitle) {
              selectedValue.textContent = optionTitle;
            }
            closeAllPopups();
          }
          if (variantPriceEl && variantPrice) {
            variantPriceEl.textContent = variantPrice.textContent;
          }
          if (variantUnitPriceEl && variantUnitPrice) {
            variantUnitPriceEl.textContent = variantUnitPrice.textContent;
          }
        });
      });
    }

    initVariantDropdown();
    // ---------------- How to Use Swiper ----------------
    if (document.querySelector("[bd-how-to-use__swiper]")) {
      new Swiper("[bd-how-to-use__swiper]", {
        navigation: {
          nextEl: ".bd-how-to-use__swiper-btn-next",
          prevEl: ".bd-how-to-use__swiper-btn-previus",
        },
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 20 },
          720: { slidesPerView: 2, spaceBetween: 20 },
          960: { slidesPerView: 2, spaceBetween: 20 }
        },
        watchSlidesProgress: true,
        draggable: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        mousewheel: { forceToAxis: true }
      });
    }

    // ---------------- Analyses Toggle ----------------
    const toggles = document.querySelectorAll('.bd-analyses__togle-btn');
    toggles.forEach(toggle => {
      toggle.addEventListener('click', function () {
        const currentContent = toggle.closest('.bd-analyses__contant-info');
        const isActive = currentContent.classList.contains('active');
        document.querySelectorAll('.bd-analyses__contant-info').forEach(content => {
          content.classList.remove('active');
        });
        if (!isActive) currentContent.classList.add('active');
      });
    });

    // ---------------- Our Promise Video ----------------
    // const wrapper = document.querySelector(".bd-our-promise__beta");
    // const btn = document.querySelector("[js-bd-promise-play-btn]");
    // if (wrapper && btn) {
    //   const video = wrapper.querySelector("video");
    //   btn.addEventListener("click", function () {
    //     if (video) {
    //       if (video.paused) {
    //         video.play();
    //       } else {
    //         video.pause();
    //       }
    //     }
    //     btn.classList.toggle("active");
    //     wrapper.classList.toggle("active");
    //   });
    // }
  const wrapper = document.querySelector(".bd-our-promise__beta");
  const btns = document.querySelectorAll("[js-bd-promise-play-btn]");
  if (wrapper && btns.length > 0) {
    const video = wrapper.querySelector("video");

    if (video) {
      btns.forEach((btn) => {
        btn.addEventListener("click", function () {
          if (video.paused) {
            video.play();
            wrapper.classList.add("active");
            btn.classList.add("active");
          } else {
            video.pause();
            wrapper.classList.remove("active");
            btn.classList.remove("active");
          }
        });
      });
      video.addEventListener("click", function () {
        video.pause();
        wrapper.classList.remove("active");
        btns.forEach((btn) => btn.classList.remove("active"));
      });
    }
  }


    // ---------------- Review Swiper ----------------
    if(window.innerWidth < 720){
      if (document.querySelector('[js-review-swiper]')) {
      new Swiper("[js-review-swiper]", {
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: {
          nextEl: ".review-swiper-btn-next",
          prevEl: ".review-swiper-button-prev",
        },
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 15 },
          720: { slidesPerView: 2, spaceBetween: 20 },
        },
        watchSlidesProgress: true,
        draggable: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        mousewheel: { forceToAxis: true }
      });
    }
    }
    // ---------------- Product Ingredients Swiper ----------------
    const ingredientsSection = document.querySelector('[js-ingredients-section]');
    if (ingredientsSection) {
      const container = ingredientsSection.querySelector('[js-product-ingredients]');
      const swiperContainer3 = ingredientsSection.querySelector('[js-product-ingredients-when3]');
        if (container) {
          const swiper = new Swiper(container, {
            slidesPerView: 5,
            spaceBetween: 36,
            loop: true,
            centeredSlides: true,
            navigation: {
              nextEl: ".js-swiper-btn-next",
              prevEl: ".js-swiper-button-prev",
            },
            breakpoints: {
              0: { slidesPerView: 1.3471, spaceBetween: 31, centeredSlides: true },
              720: { slidesPerView: 2, spaceBetween: 36, centeredSlides: true },
              960: { slidesPerView: 5, spaceBetween: 36, centeredSlides: true }
            },
            watchSlidesProgress: true,
            watchOverflow: true,
            threshold: 10,
            init: false,
            watchSlidesProgress: true,
            draggable: true,
            autoHeight: false,
            watchOverflow: true,
            threshold: 10,
            mousewheel: {
              forceToAxis: true
            },
          });
    
          const maxRotateDeg = -4;
          const maxTranslateYPx = 14;
          const curveExponent = 2;
    
          function applyCurveTransforms() {
            swiper.slides.forEach(slide => {
              const p = slide.progress;
              const abs = Math.abs(p);
              const rotate = p * maxRotateDeg;
              const translateY = Math.pow(abs, curveExponent) * maxTranslateYPx;
              const zIndex = Math.round(100 - abs * 10);
              slide.style.transform = `translateY(${translateY}px) rotate(${rotate}deg)`;
              slide.style.zIndex = zIndex;
              slide.style.opacity = Math.max(0.25, 1 - abs * 0.15);
              slide.classList.toggle('is-center', abs < 0.45);
              slide.classList.toggle('far-slide', abs > 3.0);
            });
          }
    
          swiper.on('progress', applyCurveTransforms);
          swiper.on('setTransition', (s, duration) => {
            s.slides.forEach(sl => {
              sl.style.transitionDuration = duration + 'ms';
            });
          });
          swiper.on('slideChangeTransitionEnd', applyCurveTransforms);
    
          swiper.init();
          swiper.update();
          applyCurveTransforms();
          setTimeout(() => {
            swiper.update();
            applyCurveTransforms();
          }, 50);
        }
        if (swiperContainer3) {
          const swiper = new Swiper(swiperContainer3, {
            slidesPerView: 3,
            spaceBetween: 36,
            loop: true,
            centeredSlides: true,
            navigation: {
              nextEl: ".js-swiper-btn-next",
              prevEl: ".js-swiper-button-prev",
            },
            breakpoints: {
              0: { slidesPerView: 1.3471, spaceBetween: 31, centeredSlides: true },
              720: { slidesPerView: 2, spaceBetween: 36, centeredSlides: true },
              960: { slidesPerView: 3, spaceBetween: 36, centeredSlides: true }
            },
            watchSlidesProgress: true,
            watchOverflow: true,
            threshold: 10,
            init: false,
            watchSlidesProgress: true,
            draggable: true,
            autoHeight: false,
            watchOverflow: true,
            threshold: 10,
            mousewheel: {
              forceToAxis: true
            },
          });
    
          const maxRotateDeg = -4;
          const maxTranslateYPx = 14;
          const curveExponent = 2;
    
          function applyCurveTransforms() {
            swiper.slides.forEach(slide => {
              const p = slide.progress;
              const abs = Math.abs(p);
              const rotate = p * maxRotateDeg;
              const translateY = Math.pow(abs, curveExponent) * maxTranslateYPx;
              const zIndex = Math.round(100 - abs * 10);
              slide.style.transform = `translateY(${translateY}px) rotate(${rotate}deg)`;
              slide.style.zIndex = zIndex;
              slide.style.opacity = Math.max(0.25, 1 - abs * 0.15);
              slide.classList.toggle('is-center', abs < 0.45);
              slide.classList.toggle('far-slide', abs > 3.0);
            });
          }
    
          swiper.on('progress', applyCurveTransforms);
          swiper.on('setTransition', (s, duration) => {
            s.slides.forEach(sl => {
              sl.style.transitionDuration = duration + 'ms';
            });
          });
          swiper.on('slideChangeTransitionEnd', applyCurveTransforms);
    
          swiper.init();
          swiper.update();
          applyCurveTransforms();
          setTimeout(() => {
            swiper.update();
            applyCurveTransforms();
          }, 50);
        }
      }
    });
  // ---------------- Collagen Section ----------------
  document.addEventListener('DOMContentLoaded', function () {
    const collagenBenefitsSection = document.querySelector('[js-collagen-benefits]');
    if (!collagenBenefitsSection) return;

    const COLLAGEN_SLIDER_SELECTOR = '[js-collagen-benefits-slider]';
    const DESKTOP_MIN_WIDTH = 720;
    let collagenSwiper = null;
    let collagenResizeTimer = null;

    function initCollagenSwiper() {
      const el = collagenBenefitsSection.querySelector(COLLAGEN_SLIDER_SELECTOR);
      if (!el) return;
      if (collagenSwiper) return;
      el.classList.remove('slider-disabled');

      collagenSwiper = new Swiper(COLLAGEN_SLIDER_SELECTOR, {
        slidesPerView: 2,
        spaceBetween: 20,
        loop: false,
        allowTouchMove: true,
        grabCursor: true,
        breakpoints: {
          720: { slidesPerView: 2 },
          1024: { slidesPerView: 2.4 },
        },
        watchSlidesProgress: true,
        draggable: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        mousewheel: { forceToAxis: true },
      });
    }

    function destroyCollagenSwiper() {
      const el = collagenBenefitsSection.querySelector(COLLAGEN_SLIDER_SELECTOR);
      if (!el) return;
      if (collagenSwiper) {
        collagenSwiper.destroy(true, true);
        collagenSwiper = null;
      }
      el.classList.add('slider-disabled');
    }

    function checkAndToggleCollagenSwiper() {
      const width = window.innerWidth;
      if (width >= DESKTOP_MIN_WIDTH) {
        initCollagenSwiper();
      } else {
        destroyCollagenSwiper();
      }
    }

    function onCollagenResize() {
      clearTimeout(collagenResizeTimer);
      collagenResizeTimer = setTimeout(checkAndToggleCollagenSwiper, 120);
    }

    function bindCollagenTabClicks() {
      const tabs = collagenBenefitsSection.querySelectorAll('[js-collagen-benefit-tag]');
      const slides = collagenBenefitsSection.querySelectorAll('[js-collagen-benefit-card]');

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', function () {
          tabs.forEach(t => t.classList.remove('is-active'));
          this.classList.add('is-active');

          if (collagenSwiper) {
            collagenSwiper.slideTo(index);
          } else {
            const targetSlide = slides[index];
            if (targetSlide) {
              targetSlide.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
              });
            }
          }
        });
      });
    }

    function bindCollagenDescriptionToggle() {
      const cards = collagenBenefitsSection.querySelectorAll('[js-collagen-benefit-card]');

      cards.forEach((card) => {
        const chunkAttr = card.dataset.chunkSize;
        const CHUNK_SIZE = parseInt(chunkAttr, 10) > 0 ? parseInt(chunkAttr, 10) : 600;

        const desc = card.querySelector('[js-collagen-benefit-description]');
        const btn = card.querySelector('[js-collagen-benefit-button]');

        if (!desc || !btn) return;

        const fullHTML = desc.innerHTML.trim();
        const fullText = desc.textContent.trim();
        const total = fullText.length;

        const readMoreText = btn.dataset.readMoreText || btn.textContent.trim() || 'Mehr dazu';
        const closeText = btn.dataset.closeText || 'schließen';

        if (total <= CHUNK_SIZE) {
          desc.innerHTML = fullHTML;
          btn.style.display = 'none';
          return;
        }

        let visible = CHUNK_SIZE;
        desc.innerHTML = truncateHtmlByChars(fullHTML, visible);
        btn.textContent = readMoreText;
        btn.style.display = 'inline-block';

        btn.addEventListener('click', function (e) {
          e.preventDefault();

          if (btn.textContent === readMoreText) {
            const remaining = total - visible;

            if (remaining <= CHUNK_SIZE) {
              visible = total;
              desc.innerHTML = fullHTML;
              btn.textContent = closeText;
            } else {
              visible += CHUNK_SIZE;
              desc.innerHTML = truncateHtmlByChars(fullHTML, visible);
            }
          } else {
            visible = CHUNK_SIZE;
            desc.innerHTML = truncateHtmlByChars(fullHTML, visible);
            btn.textContent = readMoreText;
          }
        });
      });

      function truncateHtmlByChars(html, limit) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;

        let remaining = limit;
        const out = document.createElement('div');

        function walk(node, parent) {
          if (remaining <= 0) return;

          if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent || '';
            if (!text) return;

            if (text.length <= remaining) {
              parent.appendChild(document.createTextNode(text));
              remaining -= text.length;
            } else {
              parent.appendChild(document.createTextNode(text.slice(0, remaining) + '...'));
              remaining = 0;
            }
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            const clone = node.cloneNode(false);
            parent.appendChild(clone);
            node.childNodes.forEach((child) => walk(child, clone));
          }
        }

        wrapper.childNodes.forEach((n) => walk(n, out));
        return out.innerHTML;
      }
    }

    // initialize all functions after DOM load
    checkAndToggleCollagenSwiper();
    bindCollagenTabClicks();
    bindCollagenDescriptionToggle();
    window.addEventListener('resize', onCollagenResize);
  });
  // ---------------- Product FAQ Section ----------------
  document.addEventListener('DOMContentLoaded', () => {
    const faqSections = document.querySelectorAll('[js-filters-section]');
    faqSections.forEach((section) => {
      const faqSliderSelector = '[js-filter-slider]';
      let faqSwiper = null;

      // Init Swiper
      function initFaqSwiper() {
        const el = section.querySelector(faqSliderSelector);
        if (!el || el.classList.contains('swiper-initialized')) return;
        faqSwiper = new Swiper(el, {
          slidesPerView: 'auto',
          centeredSlides: false,
          spaceBetween: 12,
          loop: false,
          allowTouchMove: true,
          grabCursor: true,
          breakpoints: {
            0: { centeredSlides: false },
            960: { centeredSlides: false },
            1280: { centeredSlides: false },
          },
          watchSlidesProgress: true,
          draggable: true,
          autoHeight: false,
          watchOverflow: true,
          threshold: 10,
          mousewheel: {
            forceToAxis: true
          },
        });
      }

      function initFaqAccordion() {
        const accordionHeaders = document.querySelectorAll("[js-filter-onclick]");
        const accordionRemove = document.querySelectorAll("[js-filter-remove]");
        if (accordionHeaders) {
          accordionHeaders.forEach((header) => {
            header.addEventListener("click", () => {
              const parent = header.closest("[js-filter-accordion-content]");
              document
                .querySelectorAll("[js-filter-accordion-content].active")
                .forEach((item) => {
                  if (item !== parent) {
                    item.classList.remove("active");
                  }
                });
              parent.classList.toggle("active");
            });
          });
          if (accordionRemove) {
            accordionRemove.forEach((removeBtn) => {
              removeBtn.addEventListener("click", () => {
                const parent = removeBtn.closest("[js-filter-accordion-content]");
                if (parent) {
                  parent.classList.remove("active");
                }
              });
            });
          }
        }    
      }

      function initFaqFilter() {
        const buttons = section.querySelectorAll('[js-filter-tab]');
        const grids = section.querySelectorAll('[js-filter--grid]');
        if (!buttons.length || !grids.length) return;

        buttons[0].classList.add('active');
        grids.forEach((g, i) => {
          g.style.display = i === 0 ? 'block' : 'none';
        });

        buttons.forEach((btn, index) => {
          btn.addEventListener('click', () => {
            buttons.forEach((b) => b.classList.remove('active'));
            btn.classList.add('active');

            grids.forEach((g, i) => {
              g.style.display = i === index ? 'block' : 'none';
            });

            // --- Move active tab to left ---
            if (faqSwiper) {
              faqSwiper.slideTo(index); 
            }
          });
        });
      }

      initFaqSwiper();
      initFaqAccordion();
      initFaqFilter();
    });
  });
  
  //------ top-categories-------//
  const topCategoriesSection = document.querySelector(".bd-top-categories");
  if (topCategoriesSection) {
    var swiper = new Swiper("[js-bd-top-categories-swiper-container]", { 
     slidesPerView: 4,
     spaceBetween: 20,   
     centeredSlides: true,
     loop: true,   
     slidesPerGroup: 1,
     watchSlidesProgress: true,
     draggable: true, 
     autoHeight: false, 
     watchOverflow: true, 
     threshold: 10, 
     mousewheel: {
         forceToAxis: true,
         sensitivity: .3,
     },
     breakpoints: {
         0: {  
             slidesPerView: 1.15,                        
             spaceBetween: 16,  
         },
         768: { 
             slidesPerView: 2,
             spaceBetween: 20,
         },    
         991: { 
             slidesPerView: 2.5,
             spaceBetween: 20,   
         },    
         1279: { 
             slidesPerView: 4,
             spaceBetween: 20,
         },
     }
     });
  }
    //---- our-categories ----- //
    const categoriesSection = document.querySelector(".bd-our-categories");
    if (categoriesSection) {
      var swiper = new Swiper(".bd-our-categories__main-wrapper", {
        slidesPerView: 4,
        spaceBetween: 20,
        centeredSlides: true,
        watchSlidesProgress: true,
        draggable: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        mousewheel: {
          forceToAxis: true
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 1.9,
            spaceBetween: 16,
          },
          767: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1279: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });

      document.addEventListener("DOMContentLoaded", function () {
        let playBtns = categoriesSection.querySelectorAll(".bd-our-categories__icon");
        playBtns.forEach(function (btn) {
          btn.addEventListener("click", function () {
            categoriesSection.querySelectorAll(".bd-our-categories__media-wrap video").forEach(function (vid) {
              vid.pause();
              vid.currentTime = 0;
            });
            playBtns.forEach(function (b) {
              b.classList.remove("active");
            });
            let wrapper = btn.closest(".bd-our-categories__media-wrap");
            let video = wrapper.querySelector("video");
            if (video) {
              video.play();
              btn.classList.add("active");
            }
          });
        });
      });
    }
    // artcle card //
    const articleCardsSection = document.querySelector(".bd-article-cards-section");
    if (articleCardsSection) {
      new Swiper("[bd-articles-card-slider]", {
        slidesPerView: 1.126, 
        watchSlidesProgress: true,
            draggable: true, 
            autoHeight: false, 
            watchOverflow: true, 
            threshold: 10, 
            mousewheel: {
                forceToAxis: true 
            },
        spaceBetween: 16,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            720: {
                slidesPerView: 2,
            },
        }
      });
    }
  // -- Hero banner -- //
  document.addEventListener("DOMContentLoaded", function() {
    const heroSection = document.querySelector('[js-bd-banner-slider]');
    
    if (heroSection) {
      new Swiper('[js-bd-banner-slider]', {
        slidesPerView: 'auto',
        spaceBetween: 12,
        watchSlidesProgress: true,
        draggable: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        mousewheel: {
          forceToAxis: true
        },
        breakpoints: {
          960: {
            spaceBetween: 20
          }
        }
      });

      const links = document.querySelectorAll('[bd-js-collection]');
      links.forEach(link => {
        link.addEventListener("click", function() {
          links.forEach(l => l.classList.remove("active"));
          this.classList.add("active");
        });
      });
    }
    const bannerDataSearch = document.querySelector("[banner-data-search]");
    const bannerDataSearchItem = document.querySelector("[data-quick-search]");
    const searchInput = document.querySelector(".quick-search__bar input");

    if (bannerDataSearch && bannerDataSearchItem && searchInput) {
      bannerDataSearch.addEventListener("click", () => {
        bannerDataSearchItem.classList.toggle("active");
        bannerDataSearchItem.classList.toggle("visible");
        searchInput.focus();
      });
    }
  });
  // -- reviews -- //
  const reviewsSection = document.querySelector("[js-bd-reviews-section]");
  if (reviewsSection) {
    new Swiper("[js-bd-reviews-swiper]", {
          slidesPerView: 3,
          spaceBetween: 30,
          centeredSlides: true,
          loop: true,
          navigation: {
              nextEl: ".bd-review-swiper-btn-next",
              prevEl: ".bd-review-swiper-btn-prev",
          },
          breakpoints: {
              0: {          
                  slidesPerView: 1,
                  spaceBetween: 20,
              },
              720: {
                  slidesPerView: 2,
                  spaceBetween: 20,
              },
              960: {
                  slidesPerView: 3,
                  spaceBetween: 20,
              },
              1280: {
                  slidesPerView: 4,
                  spaceBetween: 20,
              }
          },
          watchSlidesProgress: true,
          draggable: true,
          autoHeight: false,
          loop: true,
          watchOverflow: true,
          threshold: 10,
          mousewheel: {
              forceToAxis: true
          },
      });
  }
    // ---- product promotion ---- //
    const ProductPromotionSection = document.querySelector('[bd-product-promotion-section]')
    if (ProductPromotionSection) {
      function initSwiper() {
      if (window.innerWidth < 960) {
        if (!document.querySelector("[js-promotion-swiper]").swiper) {
          new Swiper("[js-promotion-swiper]", {
            slidesPerView: 1,
            spaceBetween: 0,
            watchSlidesProgress: true,
            draggable: true,
            autoHeight: false,
            watchOverflow: true,
            threshold: 10,
            mousewheel: {
                forceToAxis: true
            },
            breakpoints: {
              0: {          
                slidesPerView: 1,
                spaceBetween: 0,
              },
              720: {
                slidesPerView: 2,
                spaceBetween: 0,
              },
            },
          });
        }
      }
    }
    initSwiper();
    window.addEventListener("resize", initSwiper);  

    const popupOpenBtns = document.querySelectorAll('[js-popup-open-btn]');
    const popupCloseBtns = document.querySelectorAll('[js-bd-popup-model__close-btn]');

    popupOpenBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const targetSelector = btn.getAttribute('data-target');
        const popupModel = document.querySelector(targetSelector);
        if (popupModel) {
          popupModel.classList.add('active');
        }
      });
    });
    popupCloseBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        btn.closest('[js-bd-popup-model]').classList.remove('active');
      });
    });
    }
    // -- collection page -- //
    
    class collectionGridItem extends HTMLElement {
        constructor() {
            super();
            this.mainCollection = document.querySelector("[js-bd-main-collection]");
       
            this.desktopPosition = parseInt(this.dataset.positionDesk);
            this.mobilePosition = parseInt(this.dataset.positionMob);
           
            this.init();
        };
        init() {
            this.appendGridItem();
        };
        appendGridItem() {
            const isDesktop = document.documentElement.clientWidth > 767;
            const targetProductItem = this.mainCollection.querySelector(
                `[js-product-grid] .product-item:nth-child(${isDesktop ? this.desktopPosition : this.mobilePosition})`
            );
 
            targetProductItem
              ? targetProductItem.insertAdjacentHTML("beforebegin", this.innerHTML)
              : null;
        };
    }
 
    customElements.define('collection-grid-item', collectionGridItem);
    document.querySelectorAll("[js-copy-text-grid-item]").forEach(item => {
      const btn = item.querySelector("[js-copy-text-icon]");
      const code = item.dataset.discountCode;
      const copyTextEl = item.querySelector("[js-copy-text]");

      if (!btn || !code || !copyTextEl) return;

      btn.addEventListener("click", () => {
        if (btn.classList.contains("disabled")) return; 

        navigator.clipboard.writeText(code).then(() => {

          const originalText = copyTextEl.textContent;

          copyTextEl.textContent = "kopiert";
          btn.style.opacity = "0.7";
          btn.style.cursor = "not-allowed";
          btn.classList.add("disabled");

          setTimeout(() => {
            copyTextEl.textContent = originalText;
            btn.style.opacity = "1";
            btn.style.cursor = "pointer";
            btn.classList.remove("disabled");
          }, 1500);
        });
      });
    });

  // ==================== loading__spinner =================//
    function toggleLoading(button, loading = true) {
      const spinner = button.querySelector('.loading__spinner');
      const icon = button.querySelector('span');

      if (loading) {
          button.setAttribute('disabled', true);
          if (icon) icon.classList.add('hidden');
          if (spinner) spinner.classList.remove('hidden');
      } else {
          button.removeAttribute('disabled');
          if (icon) icon.classList.remove('hidden');
          if (spinner) spinner.classList.add('hidden');
      }
  }
// ==================== loading__spinner =================//
// subscription
class productSubscription extends HTMLElement {
    constructor() {
        super();
 
        this.subscriptionSelectionEl = this.querySelector('[js-subcription-selection]');
        this.subscriptionEl = this.querySelector('[js-subcription]');
        this.sellingPlanEl = this.querySelector('[js-selling-plan-wrap]');
        this.selectSellingId = this.querySelectorAll('[js-select-selling-id]');
 
        this.init();
    }
 
    init() {
        if (!this.subscriptionSelectionEl) return;
        this.toggleSellingPlan();
        this.updateSubscriptionValue();
 
        this.subscriptionSelectionEl.addEventListener('change', () => {
            this.toggleSellingPlan();
            this.updateSubscriptionValue();
            this.updateATCText();
        });
 
        this.selectSellingId.forEach(input => {
            input.addEventListener('change', () => {
                this.updateSubscriptionValue();
            });
        });
    }
    toggleSellingPlan() {
        if (this.subscriptionSelectionEl.checked) {
            this.sellingPlanEl.style.display = 'flex';
            this.sellingPlanEl.classList.add("active")
        } else {
            this.sellingPlanEl.style.display = 'none';
            this.sellingPlanEl.classList.remove("active")
        }
    }
    updateSubscriptionValue() {
        if (!this.subscriptionSelectionEl.checked) {
            this.subscriptionEl.value = '';
            this.subscriptionEl.setAttribute('disabled', true);
            return;
        }
 
        const checkedInput = Array.from(this.selectSellingId).find(input => input.checked);
        if (checkedInput) {
            this.subscriptionEl.value = checkedInput.value;
            this.subscriptionEl.removeAttribute('disabled');
        }
    } 
    updateATCText() {
      const atcBtnEl = document.querySelector('.product-form__cart-submit [data-add-to-cart-text]');
      if (!atcBtnEl) return;
      
      if (this.subscriptionSelectionEl?.checked) {
        atcBtnEl.textContent = "Abo in den Warenkorb"; 
      } else {
        atcBtnEl.textContent = "In den Warenkorb"; 
      }

    }
  }
 
  customElements.define('product-subscription', productSubscription);

  // custom Faq
    const faqSections = document.querySelectorAll("[js-custom-faq]");
    if (faqSections.length) {
      faqSections.forEach((section) => {
        const accordionHeaders = section.querySelectorAll("[js-faq-onclick]");
  
        if (accordionHeaders.length) {
          accordionHeaders.forEach((header) => {
            header.addEventListener("click", () => {
              const parent = header.closest("[js-faq-accordion-content]");
              section
                .querySelectorAll("[js-faq-accordion-content].active")
                .forEach((item) => {
                  if (item !== parent) {
                    item.classList.remove("active");
                  }
                });

              parent.classList.toggle("active");
            });
          });
        }
      });
    }
    // read more 
    // const container = document.querySelector('[data-disclaimer]');
    // if (!container) return;

    // const textWrap = container.querySelector('[data-disclaimer-text]');
    // const btn = container.querySelector('[data-disclaimer-toggle]');
    // if (!textWrap || !btn) return;

    // const CHUNK = 51;

    // const moreLabel = btn.textContent.trim();
    // let full = textWrap.textContent.replace(/\s+/g, ' ').trim();
    // if (moreLabel) {
    //   const idx = full.lastIndexOf(moreLabel);
    //   if (idx !== -1) full = (full.slice(0, idx) + full.slice(idx + moreLabel.length)).trim();
    // }

    // const words = full.split(/\s+/).filter(Boolean);
    // if (!words.length) return;
    // let holder = textWrap.querySelector('[data-disclaimer-chunk]');
    // if (!holder) {
    //   holder = document.createElement('span');
    //   holder.setAttribute('data-disclaimer-chunk', '');
    //   textWrap.innerHTML = '';
    //   textWrap.appendChild(holder);
    //   textWrap.appendChild(document.createTextNode(' '));
    //   textWrap.appendChild(btn);
    // }

    // let shown = Math.min(CHUNK, words.length);
    // render();

    // btn.addEventListener('click', function () {
    //   if (shown >= words.length) {
    //     shown = Math.min(CHUNK, words.length);
    //     btn.textContent = 'Mehr dazu';
    //   } else {
    //     shown = Math.min(shown + CHUNK, words.length);
    //     if (shown >= words.length) btn.textContent = 'Weniger anzeigen';
    //   }
    //   render();
    // });

    // function render() {
    //   holder.textContent = words.slice(0, shown).join(' ');
    //   if (shown < words.length) {
    //     holder.textContent += ' …';
    //   }
    // }

// PDP new
function updateSwiperHeight(entry) {
    const swiperElHeight = document.querySelector(".product-main-swiper .product__media-slide .media");
    if (swiperElHeight) {
      const swiperHeight = swiperElHeight.offsetHeight;
      document.documentElement.style.setProperty("--product-swiper-height", swiperHeight + "px");
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    const swiperElHeight = document.querySelector(".product-main-swiper .product__media-slide .media");
    if (swiperElHeight) {
      updateSwiperHeight();
      const resizeObserver = new ResizeObserver(updateSwiperHeight);
      resizeObserver.observe(swiperElHeight);
    }
  });

  document.addEventListener("click", function ({ target }) {
    if (
      target.classList.contains("R-PaginationControls__item") ||
      target.closest(".R-PaginationControls__item")
    ) {
      const scrollY = window.scrollY;
      window.scrollTo(window.scrollX, scrollY);
     
      const reviewsIoProductReviewsWidget = document.querySelector("reviewsio-product-reviews-widget");
      if (reviewsIoProductReviewsWidget) {
        reviewsIoProductReviewsWidget.scrollIntoView({ block: "start", inline: "nearest" });
      }
    }
  });
  // end above
  // ......marqueeRoot........
  const marqueeRoot = document.querySelector('.bd-marquee-tabs');
  if (marqueeRoot) {
    function Marquee(selector, speed) {
      const parentSelector = document.querySelector(selector);
      if (!parentSelector) return;

      const clone = parentSelector.innerHTML;
      const firstElement = parentSelector.children[0];
      if (!firstElement) return;

      let i = 0;
      let marqueeInterval;

      // duplicate content for seamless loop
      parentSelector.insertAdjacentHTML('beforeend', clone);
      parentSelector.insertAdjacentHTML('beforeend', clone);

      function startMarquee() {
        marqueeInterval = setInterval(function () {
          firstElement.style.marginLeft = `-${i}px`;
          if (i > firstElement.clientWidth) {
            i = 0;
          }
          i = i + speed;
        }, 0);
      }

      // Hover pause logic REMOVED as requested
      startMarquee();
    }

    window.addEventListener('load', () => Marquee('.marquee', 0.2));
  }

// ---------------- Global ARIA Toggle ----------------
function getPanel(trigger) {
  var id = trigger.getAttribute("aria-controls");
  if (!id) return null;

  // panel ko 2 tarah se dhoondo:
  // 1) data-content-panel attribute se
  // 2) ya direct id se
  return (
    document.querySelector('[data-content-panel="' + id + '"]') ||
    document.getElementById(id)
  );
}

function isPanelOpen(panel) {
  if (!panel) return false;

  // SIRF yahi state valid hai:
  return (
    panel.hasAttribute("open") ||
    panel.classList.contains("is-open") ||
    panel.classList.contains("open") ||
    panel.classList.contains("active")
  );
}

function syncTrigger(trigger) {
  if (!trigger) return;

  var panel = getPanel(trigger);

  if (panel) {
    var expanded = isPanelOpen(panel);

    if (trigger.hasAttribute("aria-expanded")) {
      trigger.setAttribute("aria-expanded", expanded ? "true" : "false");
    }

    if (trigger.hasAttribute("aria-pressed")) {
      trigger.setAttribute("aria-pressed", expanded ? "true" : "false");
    }

    return;
  }

  if (trigger.hasAttribute("aria-pressed")) {
    var active =
      trigger.classList.contains("is-active") ||
      trigger.classList.contains("active");
    trigger.setAttribute("aria-pressed", active ? "true" : "false");
  }
}

function syncAllAriaState() {
  var triggers = document.querySelectorAll("[data-aria-toggle]");
  triggers.forEach(syncTrigger);
}

document.addEventListener(
  "click",
  function (event) {
    var trigger = event.target.closest("[data-aria-toggle]");
    if (!trigger) return;

    setTimeout(function () {
      syncTrigger(trigger);
    }, 0);
  },
  true
);

var ariaObserver = new MutationObserver(function () {
  syncAllAriaState();
});

ariaObserver.observe(document.documentElement, {
  attributes: true,
  subtree: true,
  attributeFilter: ["class", "open"]
});

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", syncAllAriaState);
} else {
  syncAllAriaState();
}



document.addEventListener("keydown", function (event) {
  if (event.key !== "Enter" && event.key !== " ") return;

  const target = event.target;

  const tag = target.tagName;
  if (
    tag === "BUTTON" ||
    tag === "A" ||
    tag === "INPUT" ||
    tag === "TEXTAREA" ||
    target.isContentEditable
  ) {
    return;
  }

  const pseudoButton = target.closest('[role="button"][tabindex]');
  if (!pseudoButton) return;

  event.preventDefault();

  pseudoButton.click();
  });
  const customMainArticle = document.querySelector('.custom-main-article');
  if (customMainArticle) {
      document.addEventListener('DOMContentLoaded', function() {
      document.getElementById('txt-mol').addEventListener("input", vd_calculate_mol);
      document.getElementById('txt-gewicht').addEventListener("input", vd_calculate);
      document.getElementById('txt-d-aktuell').addEventListener("input", vd_calculate);
      document.getElementById('txt-d-tage').addEventListener("input", vd_calculate);
      document.getElementById('txt-d-ziel').addEventListener("input", vd_calculate);
      vd_calculate();
    });

    function vd_calculate_mol() {
        var nMol = document.getElementById('txt-mol').value;
        var nG = nMol / 2.5;

        document.getElementById('ng').textContent = nG.toFixed(2);
    }

    function vd_calculate() {
        var kgPat = document.getElementById('txt-gewicht').value;
        var vitDZW = document.getElementById('txt-d-ziel').value;
        var vitDB = document.getElementById('txt-d-aktuell').value;
        //var vR = document.getElementById('txt-d-verlust').value;
        var vR = 0.84;
        //var stF = document.getElementById('txt-d-steigerung').value;
        var stF = 140;
        var tage = document.getElementById('txt-d-tage').value;
        var kf = 1;
        var dBedarf = 0;
        var dAT = 0;
        var dDT = 0;
        kf = 1;

        dBedarf = (vitDZW - vitDB) * kgPat * kf * stF;
        dDT = vitDZW * kgPat * (vR/100) * kf * stF;
        dAT = (dBedarf / tage) + dDT;
        var dATT = Math.round(dAT / 800);

        document.getElementById('bedarf').textContent = vd_formatNumber(dBedarf.toFixed(0),'.');
        document.getElementById('tagesdosis').textContent = vd_formatNumber(dAT.toFixed(0),'.');
        document.getElementById('tagesdosis-tropfen').textContent = vd_formatNumber(dATT.toFixed(0),'.');
        document.getElementById('erhaltungsdosis').textContent = vd_formatNumber(dDT.toFixed(0),'.');
    }

    function vd_formatNumber(number, delimiter) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
    }

    function vd_formatNumber(number, divider) {

        number = '' + number;
        if (number.length > 3) {
            var mod = number.length % 3;
            var output = (mod > 0 ? (number.substring(0,mod)) : '');
            for (let i=0 ; i < Math.floor(number.length / 3); i++) {
                if ((mod == 0) && (i == 0))
                    output += number.substring(mod+ 3 * i, mod + 3 * i + 3);
                else
                    output+= divider + number.substring(mod + 3 * i, mod + 3 * i + 3);
            }
            return (output);
        }
        else return number;
    }
  }
  // main article vitamin calculator end

})(); 